import React, { useState } from "react";

import MyForm from "./Components/Form/MyForm.js";
import MyTable from "./Components/Table/MyTable.js";
import MyAppBar from "../MyAppBar/MyAppBar.js";

export default function Usinas() {
    const [open, setOpen] = useState(false)
    const [data, setData] = useState(null)
    const [reload, setReload] = useState(false);

    return (
        <>
            < MyAppBar />
            < MyTable
                reload={reload}
                setOpen={setOpen}
                setData={setData}
                setReload={setReload}
            />
            < MyForm
                data={data}
                open={open}
                setOpen={setOpen}
                setReload={setReload}
            />
        </>
    );
}
